import { useCallback } from 'react';
import { useMutation } from '@ts-core/lib/apollo';

import { getErrorMessage } from '@ts-core/lib/apollo';
import { useSnackbarNotifications } from '@ts-core/core/hooks/ui';

import {
  createExerciseMediaMutation,
  CreateExerciseMediaMutationResult,
  CreateExerciseMediaMutationVariables,
} from '../graphql/mutations/createExerciseMediaMutation';
import { ExerciseMediaItem, CreateExerciseMediaItemInput } from '../types';

interface ExerciseMediaActionsHookInput {
  courseId: string;
  subjectId: string;
}

interface ExerciseMediaActionsHookOutput {
  onCreateExerciseMediaItem: (input: CreateExerciseMediaItemInput, onSuccess: (mediaItem: ExerciseMediaItem) => void) => void;

  createExerciseMediaItemLoading: boolean;
  createExerciseMediaItemError?: string;
}

export default function useExerciseMediaActions(input: ExerciseMediaActionsHookInput): ExerciseMediaActionsHookOutput {
  const { courseId, subjectId } = input;
  const { showErrorNotification } = useSnackbarNotifications();

  const [createExerciseMediaItem, { loading: createExerciseMediaItemLoading, error: createExerciseMediaItemError }] = useMutation<
    CreateExerciseMediaMutationResult,
    CreateExerciseMediaMutationVariables
  >(createExerciseMediaMutation, { onError: showErrorNotification });
  const onCreateExerciseMediaItem = useCallback(
    (input: CreateExerciseMediaItemInput, onSuccess: (mediaItem: ExerciseMediaItem) => void) => {
      createExerciseMediaItem({
        variables: {
          courseId,
          subjectId,
          input,
        },
      }).then(({ data }) => {
        if (data) {
          onSuccess(data.exerciseMediaItem);
        }
      });
    },
    [createExerciseMediaItem, courseId, subjectId]
  );

  return {
    onCreateExerciseMediaItem,
    createExerciseMediaItemLoading,
    createExerciseMediaItemError: getErrorMessage({ error: createExerciseMediaItemError }),
  };
}
